import ApiService from '@/helpers/api.service';

const API = new ApiService();

const ENDPOINT = '/vc-rewards';

export const state = {
  vcRewards: [],
  vcRewardsPage: {
    totalRows: 0
  },
  userList : [],
  userListPage: {
    totalRows: 0
  },
  errors: null
}

export const mutations = {
  UPDATE_USERS_LIST(state, userList){
    try {
      for(let x of userList){
        if(x.cognito_sub == null){
          x["$isDisabled"] = true;
        }
      } 
    } catch (error) {
      console.log("Update user list ERROR: ", error);
    }
    state.userList = userList;
  },
  UPDATE_USERS_LIST_PAGE(state, pageInfo){
    state.userListPage = pageInfo;
  },
  SET_ERROR(state, errors){
    state.errors = errors;
  },
  UPDATE_VC_REWARD_LIST(state, vcRewards){
    state.vcRewards = vcRewards;
  },
  UPDATE_VC_REWARD_PAGE(state, pageInfo){
    state.vcRewardsPage = pageInfo;
  },
}

export const actions = {
  fetchAllUsers(context, params){
    return new Promise((resolve, reject) => {
      API.post(`${ENDPOINT}/fetchAllUsers`, params)
        .then(({ data }) => {
          if(data.status == "err"){
            reject();
          } else {
            context.commit('UPDATE_USERS_LIST', data.message.rows);
            context.commit('UPDATE_USERS_LIST_PAGE', {
              totalRows: data.message.pageInfo.total
            });
            resolve(data.message);
          }
        })
        .catch(({ response }) => {
          context.commit('SET_ERROR', response.data.errors);
          reject();
        });
    });
  },
  addUserVC(context, params){
      return new Promise((resolve, reject) => {
        console.log(params);
          API.post(`${ENDPOINT}/addUserVC`, params)
          .then(({ data }) => {
              if(data.status === "ok") {
                  resolve()
              } else {
                  reject(data.message)
              }
          })
          .catch(({ response }) => {
              context.commit('SET_ERROR', response.data.errors);
              reject(response);
          });
      });
  },
  fetchUsersVCLogs(context, params){
    console.log(params);
    return new Promise((resolve, reject) => {
      API.post(`${ENDPOINT}/fetchUsersVCLogs`, params)
        .then(({ data }) => {
          if(data.status == "err"){
            reject(data.message);
          } else {
            context.commit('UPDATE_VC_REWARD_LIST', data.message.rows);
            context.commit('UPDATE_VC_REWARD_PAGE', {
              totalRows: data.message.pageInfo.total
            });
            resolve(data.message);
          }
        })
        .catch(({ response }) => {
          context.commit('SET_ERROR', response.data.errors);
          reject();
        });
    });
  },
  
  
}

export const getters = {}